/**
 * Split component props into field props (for final form) and other props.
 * Based on: https://final-form.org/docs/react-final-form/types/FieldProps
 * @param {object} props
 * @returns {[object, object]}
 */
export function splitFieldProps(props) {
    const {
        name,
        afterSubmit,
        allowNull,
        beforeSubmit,
        children,
        component,
        data,
        defaultValue,
        format,
        formatOnBlur,
        i18nIsDynamicList,
        initialValue,
        isEqual,
        multiple,
        parse,
        subscription,
        type,
        validate,
        validateFields,
        value,
        ...otherProps
    } = props;

    return [
        {
            name,
            afterSubmit,
            allowNull,
            beforeSubmit,
            children,
            component,
            data,
            defaultValue,
            format,
            formatOnBlur,
            i18nIsDynamicList,
            initialValue,
            isEqual,
            multiple,
            parse,
            subscription,
            type,
            validate,
            validateFields,
            value,
        },
        otherProps,
    ];
}
